import { some } from "lib";
export const invoicesApiSelector = ({ state }) => state.api.invoices;
export const invoicesApiPageSelector = ({ state, page }) =>
  invoicesApiSelector({ state }).pages[page] || {};

export const isAnyInvoicesFetching = ({ state }) => {
  const invoicesApi = invoicesApiSelector({ state });
  return some(invoicesApi.pages, { isFetching: true });
};
